'use strict'
var Joi = require(process.env.APP_ENV === 'browser' ? 'joi-browser' : 'joi')

var schemas = {
  'auth.login': Joi.object().keys({
    email: Joi.string().trim().email().required(),
    password: Joi.string().trim().required()
  }),
  'editUser': Joi.object().keys({
    id: Joi.string().trim().allow(''),
    displayName: Joi.string().trim().required(),
    email: Joi.string().email().trim().required(),
    accessGranted: Joi.boolean().required(),
    role: Joi.string().valid('user', 'admin').required(),
    password: Joi.any().when('id', {is: '', then: Joi.string().trim().required(), otherwise: Joi.string().trim().optional().allow(null).allow('')}),
    passwordCheck: Joi.any().valid(Joi.ref('password')).options({
      language: {
        any: {
          allowOnly: '!!Passwords do not match'
        }
      }
    }).when('password', {is: '', then: Joi.string().trim().optional().allow(null).allow(''), otherwise: Joi.string().trim().required()})
  }),
  'editFeed': Joi.object().keys({
    title: Joi.string().trim().required(),
    channels: Joi.array().min(1),
    strategy: Joi.string().trim().required(),
    postTypes: Joi.array().min(1),
    thresholdLike: Joi.number().integer().allow(null).allow('').optional(),
    thresholdShare: Joi.number().integer().allow(null).allow('').optional(),
    thresholdComment: Joi.number().integer().allow(null).allow('').optional(),
    thresholdReach: Joi.number().integer().allow(null).allow('').optional(),
    thresholdClick: Joi.number().integer().allow(null).allow('').optional(),
    maxItemNum: Joi.number().integer().required().min(1),
    useLinks: Joi.string().trim().required(),
    useContents: Joi.string().trim().required(),
    topCount: Joi.any().when('strategy', {is: 'top', then: Joi.number().integer().required().min(1), otherwise: Joi.optional().allow(null).allow('')}),
    topOrder: Joi.any().when('strategy', {is: 'top', then: Joi.string().trim().required(), otherwise: Joi.optional().allow(null).allow('')}),
    topTime: Joi.any().when('strategy', {is: 'top', then: Joi.string().trim().required(), otherwise: Joi.optional().allow(null).allow('')}),
    topHours: Joi.number().integer().required().min(1),
    readTimeOffsetInDays: Joi.number().integer().required().min(0)
  }),
  'editAnalytics': Joi.object().keys({
    title: Joi.string().trim().required(),
    channels: Joi.array().min(1),
    postSource: Joi.string().trim().required(),
    interval: Joi.object().required().keys({
      min: Joi.date().required(),
      max: Joi.date().required()
    })
  }),
  'editInsightsSettings': Joi.object().keys({
    channels: Joi.array().min(0)
  }),
  'queryInsightsData': Joi.object().keys({
    channels: Joi.array().min(1),
    postTypes: Joi.array().min(1),
    interval: Joi.object().required().keys({
      min: Joi.date().required(),
      max: Joi.date().required()
    })
  })
}

module.exports = schemas



// WEBPACK FOOTER //
// ./src/schemas.js